import { useEffect } from 'react';
import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';
import { DynamicModuleLoader } from 'redux-dynamic-modules-react-18';
import { Modules, loadReduxModules } from 'src/common/reduxStore/modules';
import { getPageMetaData } from 'src/modules/parkplusStoreV2/services/home/getPageMetadata';
import Home from 'src/modules/parkplusStoreV2/components/Home';

import { APP_BAR, HANDLE_HEADER } from 'core-lib/constants/nativeBridge';
import { passMessageToNative } from 'core-lib/utils/nativeBridge';
import { isParkPlusWebView } from 'core-lib/utils/source';
export async function getServerSideProps(context) {
  const data = await getPageMetaData();
  return data;
}

function ParkplusStore({ data }) {
  useEffect(() => {
    if (isParkPlusWebView()) {
      passMessageToNative(HANDLE_HEADER, null, { show: false, backBtn: false });
      passMessageToNative(APP_BAR, null, null);
    }
  }, []);

  return (
    <DynamicModuleLoader modules={loadReduxModules([Modules.ParkplusStoreV2])}>
      <Home data={data} />
    </DynamicModuleLoader>
  );
}

export default ParkplusStore;
